export default __webpack_public_path__ + "1c24aca8493311579a9a8cdaf5cd613a.svg";